import { render } from "./Claim3_Adm.vue?vue&type=template&id=7ae69f15&scoped=true"
import script from "./Claim3_Adm.vue?vue&type=script&lang=js"
export * from "./Claim3_Adm.vue?vue&type=script&lang=js"

import "./Claim3_Adm.vue?vue&type=style&index=0&id=7ae69f15&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7ae69f15"

export default script